import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  body: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  field: {
    width: "100%",
  },
});
